import { createContext } from 'react';

type TransferContextProps = {
  status: string;
};
const TransferContext = createContext<TransferContextProps>({
  status: '',
});

export default TransferContext;
